import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(VueCookies)
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex'
import i18n from '../translation/index.js'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'

import deviceStore from './deviceStore'

const logrocketPlugin = createPlugin(LogRocket);
// axios.defaults.baseURL = 'localhost:3004';
axios.defaults.baseURL = document.getElementById('reports_url').value;
axios.defaults.withCredentials = true;

axios.defaults.params = {}
axios.defaults.params['lang'] = $cookies.get('lang')

const user_company = document.getElementById('user_company').value

const {theme} = resolveConfig(tailwindConfig)

const myReports = 'my_reports'
const reportsStore = {
  state: {
    isValid: false,
    user_logged_in: null,
    company_id: user_company,
    loading: 0,
    charts: [{
        id: 1,
        name: 'Pie Chart',
        model: 'PieChart'
      }
    ],
    aggregateTypes: [{
        id: 1,
        name: 'Average',
        model: 'AVG'
      }, {
        id: 2,
        name: 'Min value',
        model: 'MIN'
      }, {
        id: 3,
        name: 'Max value',
        model: 'MAX'
      }, {
        id: 4,
        name: 'Total',
        model: 'SUM'
      }
    ],
    additionalGroupByTypes: [{
        id: 1,
        name: 'Year',
        model: 'YEAR'
      }, {
        id: 2,
        name: 'Month',
        model: 'MONTH'
      }, {
        id: 3,
        name: 'Day',
        model: 'DAY'
      }
    ],
    services: [],
    types: [],
    reports: {
      active: {
        serviceType: null,
        type: null,
        report: null,
      },
      chosen: {
        serviceType: null,
        type: null
      },
      list: []
    },
    shares: {
      list: []
    },
    result: null,
    columnOrder: [],
    scheduleOptions: {
      frequency: ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Yearly'],
      ends: ['Never', 'On', 'After']
    },
    sharedUsers: [],
    userType: [],
    newReport: {
      id: null,
      name: '',
      view_columns: [],
      view_columns_stringify: null,
      group_by: [],
      group_by_stringify: null,
      stack_by: null,
      stack_by_stringify: null,
      service_group: [],
      service_group_stringify: null,
      device_active: true,
      date_from: null,
      date_to: null,
      backward_interval: null,
      map: null,
      cover_type: 0,
      type_id: '', //(model:Type:id),
      schedule_id: '', // (model:Schedule:id),
      chart_id: null, //(model: Chart: name e.g. 'Pie Chart'),
      chart_name: null, //(model: Chart: name e.g. 'Pie Chart'),
      service_name: "Soti", //(model: Service: name e.g. 'Soti'),
      filters: [],
      filters_stringify: null,
      order_by: [],
      order_by_stringify: null, //{"imei": "01", "memory": "4"}
      aggregate: [],
      aggregate_stringify: null,
      additionalGroupBy: [],
      additionalGroupBy_stringify: null,
    },
    users: null,
    activeTab: 0,
    reportChoosingCollapsed: false,
    lastRunChartType: null,
    lastRunStackBy: null,
    lastRunGroupBy: null,
    generatedReport: null,
    calendarAttributes: [{
      key: 'today',
      highlight: {
        fillMode: 'outline',
        style: {
          borderColor: theme.colors.sparkYellow
        }
      },
      dates: new Date(),
    }],
    specialTypes: [
      i18n.t('my_own_report'),
      i18n.t('my_company_report')
    ],
  },
  getters: {
    isValid: state => {
      if(state.newReport.name.trim().length) {
        return true
      } else {
        return false
      }
    },
    isLoading: state => state.loading,
    reportsByServiceType: state => {
      let objectsToTop = []
      let outputTypes = state.reports.list
      state.specialTypes.forEach(specialType => {
        let foundType = state.reports.list.find(type => type.name === specialType)
        if(foundType) {
          objectsToTop.push(foundType)
        }

        outputTypes = outputTypes.filter(type => type.name != specialType)
      })
      let map = new Map()
      map.set(myReports, objectsToTop)
      outputTypes.forEach(element => {
        if (!element.report[0]) return
        if (!map.has(element.report[0].type)) {
          map.set(element.report[0].type, [])
        }
        map.get(element.report[0].type).push(element)
      })

      return map
    },
    reportsTypeList: state => {
      let objectsToTop = []
      let outputTypes = state.reports.list
      state.specialTypes.forEach(specialType => {
        let foundType = state.reports.list.find(type => type.name === specialType)
        if(foundType) {
          objectsToTop.push(foundType)
        }

        outputTypes = outputTypes.filter(type => type.name != specialType)
      })

      outputTypes.sort((a, b) => {
        return a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)
      })
      outputTypes = objectsToTop.concat(outputTypes)

      return outputTypes
    },
    restrictedReportsTypeList: state => { 
      const ownReport = state.reports.list.find(report_type => report_type.user_type)
      if(ownReport !== undefined) {
        return [ ownReport ]
      }
      return []
    },
    findService: state => service_name => { 
      return state.services.find(service => service.name == service_name)
    },
    findReport: state => report_id => {
      let skip = false;
      let output;
      state.reports.list.forEach(function (report_type) {
        if (!skip) {

          report_type.report.forEach(function (report) {
            if (!skip) {
              if (report.id === report_id) {
                skip = true
                output = report
              }
            }
          })
        }
      })
      return output
    },
    activeReport: state => state.reports.active,
    reportChoosingCollapsed: state => state.reportChoosingCollapsed,
    lastRunChartType: state => state.lastRunChartType,
    lastRunStackBy: state => state.lastRunStackBy,
    lastRunGroupBy: state => state.lastRunGroupBy,
    chosenReport: state => state.reports.chosen,
    companyId: state => state.company_id,
    activeTab: state => state.activeTab,
    allCharts: state => state.charts,
    allAggregates: state => state.aggregateTypes,
    allAdditionalGroupBy: state => state.additionalGroupByTypes,
    allAggregateColumns: state => {
      const columns = []
      state.services.forEach(function(service){
        if(service.columns != null){
          for (const [key, value] of Object.entries(service.columns)) {
            // , 'date' temporarily removed from aggregate no time line support in charts
            if (['integer', 'float'].includes(value)) {
              columns.push({
                name: key,
                type: value,
                service: service.name,
                value: null,
                like: true
              })
            }
          }
        }
      })
      return columns
    },
    allDateColumns: state => {
      const columns = []
      state.services.forEach(function(service){
        if(service.columns != null){
          for (const [key, value] of Object.entries(service.columns)) {
            if (['date'].includes(value)) {
              columns.push({
                name: key,
                type: value,
                service: service.name,
                value: null,
                like: true
              })
            }
          }
        }
      })
      return columns
    },
    calendarAttributes: state => state.calendarAttributes,
    allColumns: state => {
      const columns = []
      state.services.forEach(function(service){
        if(service.columns != null){
          for (const [key, value] of Object.entries(service.columns)) {
            columns.push({
              name: key,
              type: value,
              service: service.name,
              value: null,
              like: true
            })
          }
        }
      })
      return columns
    },
    schedules: state => {
      let listOfSchedules = [];
      state.reports.list.forEach(reportType => {
        reportType.report.forEach(report => {
          if (report.schedule.length) {
            let tempArray = report.schedule
            // add report name to each schedule
            tempArray.forEach(schedule => schedule.report = report)
            listOfSchedules.push(...tempArray)
          }
        })
      })
      return listOfSchedules
    },
    shares: state => {
      let listOfShares = [];
      state.shares.list.forEach(reportType => {
        reportType.report.forEach(report => {
          if (report.shared != null) {
            let exists = listOfShares.find(share => share.name == report.name)
            if(exists === undefined) {
              listOfShares.push({'id': report.id, 'name': report.name, 'type_name': reportType.name, 'shared_report_id': report.sharedReport, 'user_names': [ report.user_name ]})
            }
            else {
              const user_exists = exists.user_names.find(user => user === report.user_name)
              if(user_exists === undefined) {
                exists.user_names.push(report.user_name)
              }
            }
          }
        })
      })
      return listOfShares
    },
    chartName: state =>{
      if(state.newReport.chart_id){
        return state.charts.find(chart => chart.id === state.newReport.chart_id).name.replace(/\s/g, '')
      } else {
        return null
      }
    },
    scheduleOptions: state => state.scheduleOptions,
    paths: state => state.services[0].groups,
    newReport: state => state.newReport,
    users: state => state.users,
    usersToShareWith: state => state.users.filter((user) => user.email !== state.user_logged_in.email),
    sharedUsers: state => state.sharedUsers,
    result: state => state.result,
    columnOrder: state => state.columnOrder,
    userType: state => state.userType,
    specialTypes: state => state.specialTypes
  },
  mutations: {
    reset: (state) => {
      Vue.set(state.reports, 'active', {
        serviceType: null,
        type: null,
        report: null,
      })
      Vue.set(state.reports, 'chosen', {
        serviceType: null,
        type: null,
      })
      Vue.set(state, 'loading', 0)
      Vue.set(state, 'activeTab', 0)
      Vue.set(state, 'generatedReport', null)
      Vue.set(state, 'result', null)
      Vue.set(state, 'columnOrder', [])
      Vue.set(state, 'newReport', {
          id: null,
          name: '',
          view_columns: [],
          view_columns_stringify: null,
          group_by: [],
          group_by_stringify: null,
          stack_by: null,
          stack_by_stringify: null,
          service_group: [],
          service_group_stringify: null,
          device_active: true,
          backward_interval: null,
          date_from: null,
          date_to: null,
          map: null,
          cover_type: 0,
          type_id: null,
          schedule_id: null,
          chart_id: null,
          chart_name: null,
          service_name: null,
          order_by: [],
          order_by_stringify: null,
          filters: [],
          filters_stringify: null,
          aggregate: [],
          aggregate_stringify: null,
          additionalGroupBy: [],
          additionalGroupBy_stringify: null
      })
    },
    setActiveTab: (state,tabIndex) => Vue.set(state,'activeTab', tabIndex),
    setReportChoosingCollapsed: (state, collapsed) => Vue.set(state, 'reportChoosingCollapsed', collapsed),
    setLastRunChartType: (state, lastRunChartType) => Vue.set(state, 'lastRunChartType', lastRunChartType),
    setLastRunStackBy: (state, lastRunStackBy) => Vue.set(state, 'lastRunStackBy', lastRunStackBy),
    setLastRunGroupBy: (state, lastRunGroupBy) => Vue.set(state, 'lastRunGroupBy', lastRunGroupBy),
    setServices: (state, data) => Vue.set(state, 'services', data),
    setTypes: (state, data) => Vue.set(state, 'types', data),
    setUsers: (state, data) => Vue.set(state, 'users', data),
    setCharts: (state, data) => Vue.set(state, 'charts', data),
    setSharedUsers: (state, data) => Vue.set(state, 'sharedUsers', data),
    setResult: (state, data) => {
      state.result = Object.freeze(data)
      Vue.set(state, 'columnOrder', data.columns)
    },
    setReports: (state, data) => Vue.set(state.reports, 'list', data),
    setShares: (state, data) => { Vue.set(state.shares, 'list', data) },
    setLoading: (state, status) => {
      let val = state.loading
      if(status){
        val++
      } else {
        val--
      }
      Vue.set(state, 'loading', val)
    },
    setColumnOrder: (state, data) => {
      if (state.result === null) {
        return
      }
      let temp = state.columnOrder
      temp = temp.slice(0, data.groupByLength)
      Vue.set(state, 'columnOrder', temp.concat(data.columns))
    },
    chooseServiceType: (state, data) => {
      Vue.set(state.reports.chosen, 'type', null)
      Vue.set(state.reports.chosen, 'serviceType', data)
    },
    chooseReportType: (state, data) => Vue.set(state.reports.chosen, 'type', data),
    selectReportType: (state, data) => Vue.set(state.reports.active, 'type', data),
    selectReport: (state, data) => {
      let reportType = state.reports.list.find(type => type.report.find(report => report.id === data.id))
      if (reportType) {
        Vue.set(state.reports.active, 'type', reportType.id)
        Vue.set(state.reports.chosen, 'type', reportType.id)
        Vue.set(state.reports.active, 'serviceType', state.specialTypes.find(specialType => specialType === reportType.name) === undefined ? reportType.report[0].type : myReports)
      }
      Vue.set(state.reports.active, 'report', data.id)
      Vue.set(state.newReport, 'chart_id', data.chart_id)
      Vue.set(state.newReport, 'aggregate_stringify', data.aggregate)
      Vue.set(state.newReport, 'aggregate', data.aggregate ? JSON.parse(data.aggregate) : [])
      Vue.set(state.newReport, 'additionalGroupBy_stringify', data.additionalGroupBy)
      Vue.set(state.newReport, 'additionalGroupBy', data.additionalGroupBy ? JSON.parse(data.additionalGroupBy) : [])
      Vue.set(state.newReport, 'cover_type', data.cover_type)
      Vue.set(state.newReport, 'backward_interval', data.backward_interval ? data.backward_interval : null)
      Vue.set(state.newReport, 'date_from', data.date_from)
      Vue.set(state.newReport, 'date_to', data.date_to)
      Vue.set(state.newReport, 'map', data.map)
      Vue.set(state.newReport, 'service_name', data.service.name)
      Vue.set(state.newReport, 'device_active', data.device_active)
      Vue.set(state.newReport, 'service_group_stringify', data.service_group)
      Vue.set(state.newReport, 'service_group', JSON.parse(data.service_group))
      Vue.set(state.newReport, 'filters_stringify', data.filters)
      Vue.set(state.newReport, 'filters', JSON.parse(data.filters))
      Vue.set(state.newReport, 'group_by_stringify', data.group_by)
      Vue.set(state.newReport, 'stack_by_stringify', data.stack_by)
      const groupByParse = JSON.parse(data.group_by)
      let group_by_output = []
      if (groupByParse.length) {
        groupByParse.forEach(item => {
          group_by_output.push({
            name: item,
            type: '',
            label: item
          })
        })
      }
      Vue.set(state.newReport, 'group_by', group_by_output)
      let stack_by_output = null
      if (data.stack_by !== null) {
        stack_by_output = {
          name: data.stack_by,
          type: '',
          label: i18n.t(data.stack_by)
        }
      }
      Vue.set(state.newReport, 'stack_by', stack_by_output)

      Vue.set(state.newReport, 'id', data.id)
      Vue.set(state.newReport, 'name', data.name)
      Vue.set(state.newReport, 'order_by_stringify', data.order_by)
      const orderByParse = data.order_by ? Object.entries(JSON.parse(data.order_by)) : []
      let order_by_output = []
      if (orderByParse.length){
        orderByParse.forEach(item => {
          order_by_output.push({
            name: item[0],
            order_by: item[1],
            label: item[0]
          })
        })
      }
      Vue.set(state.newReport, 'order_by', order_by_output)
      Vue.set(state.newReport, 'type_id', data.type_id)
      Vue.set(state.newReport, 'view_columns_stringify', data.view_columns)
      const viewColumnsParse = data.view_columns ? Object.entries(JSON.parse(data.view_columns)) : []
      let view_columns_output = []
      if (viewColumnsParse.length) {
        viewColumnsParse.forEach(item => {
          view_columns_output.push({
            name: item[0],
            type: item[1],
            label: item[0]
          })
        })
      }
      Vue.set(state.newReport, 'view_columns', view_columns_output)
      Vue.set(state, 'result', null)
      Vue.set(state, 'columnOrder', [])
    },
    setNewReportItem: (state, data) => {
      Vue.set(state.newReport, Object.keys(data)[0], Object.values(data)[0])
      let payload = {};
      switch (Object.keys(data)[0]){
        case 'order_by': // {"imei": "desc"}
          payload = {};
          Object.values(data)[0].forEach((item) => {
            payload = { ...payload, [item.name]: item.order_by}
          })
          Vue.set(state.newReport, 'order_by_stringify', JSON.stringify(payload))
          break;
        case 'filters':
        case 'aggregate':
        case 'additionalGroupBy':
          Vue.set(state.newReport, Object.keys(data)[0] + '_stringify', JSON.stringify(Object.values(data)[0]))
          break;
        case 'view_columns':
          payload = {};
          Object.values(data)[0].forEach((item) => {
            payload = {...payload, [item.name]: item.type}
          })
          Vue.set(state.newReport, 'view_columns_stringify', JSON.stringify(payload))
          break;
        case 'group_by':
          payload = [];
          if (Object.values(data)[0] != null) {
            const val = Object.values(data)[0]
            if(Array.isArray(val)){
              val.forEach(item => {
                payload = [...payload, item.name]
              })
            } else {
              payload = [...payload, val.name]
            }
          }
          Vue.set(state.newReport, 'group_by_stringify', JSON.stringify(payload))
          break;
        case 'stack_by':
          payload = null
          if (Object.values(data)[0] !== null) {
            payload = Object.values(data)[0].name
          }
          Vue.set(state.newReport, 'stack_by_stringify', payload)
          break;
      }
    },
    setUserType: (state, data) => {
      Vue.set(state, 'userType', data)
    },
    setUserLoggedIn: (state,data) => {
      Vue.set(state, 'user_logged_in', data)
    }
  },
  actions: {
    getQueryToLogin({commit}) {
      let output = null

      const email = document.getElementById('user_login').value,
            password = document.getElementById('user_password').value,
            code = document.getElementById('code').value;
      if (email && password && code){
        output = {
          email,
          password,
          code
        }
        commit('setUserLoggedIn', output)
      }
      return output
    },
    async getToken() {
      await axios.get('/sanctum/csrf-cookie')
    },
    async autologin({dispatch}) {
      let output = false;
      const credentials = await dispatch('getQueryToLogin')
      if (credentials) {
        // LogRocket.identify(credentials.email, {
        //   email: document.getElementById('user_login').value,
        //   name: document.getElementById('user_login').value,
        //   company: document.getElementById('user_company').value,
        // });
        await dispatch('login', credentials).then(response => {
          output = response
        })
      }
      return output
    },
    async login({commit, dispatch}, data = null) {
      if (data) {
        await dispatch('getToken')
        await axios.post('/login', data)
        return true
      } else {
        return false
      }
    },
    // Get list of all Services (e.g. Soti)
    async getServices({commit, rootGetters}){
      commit('setLoading', true)
      const id = rootGetters.companyId
      await axios.get('/companies/'+ id +'/services').then(function(response) {
        if (response.status === 200) {
          commit('setServices', response.data)
          if (rootGetters.activeReport.report) {
            const service = rootGetters.findReport(rootGetters.activeReport.report).service
            let output = rootGetters.result
            if (output) {
              output = { ...output, service: service };
              Object.freeze(output)
              commit('setResult', output)
            }
          }
        }
        commit('setLoading', false)
      })
    },
    // Get list of all Types
    async getTypes({
        commit,
        rootGetters
      }) {
      commit('setLoading', true)
      const id = rootGetters.companyId
      await axios.get('/companies/'+ id +'/types').then(function(response) {
        if (response.status === 200) {
          commit('setTypes', response.data)
          const userType = response.data.filter(type => type.user_type === 1)
          commit('setUserType', userType)
        }
        commit('setLoading', false)
      })
    },
    // Get list of users
    async getUsers({ commit, rootGetters}, search = null) {
      const searchPhrase = search != null ? search : ''
      const id = rootGetters.companyId
      await axios.get('/companies/' + id + '/users' + '?s=' + searchPhrase).then(function (response) {
        if (response.status === 200) {
          commit('setUsers', response.data)
        }
      })
    },
    // Create new type
    async createType({
      commit, rootGetters
    }, name) {
      if(name.length){

        commit('setLoading', true)
        const id = rootGetters.companyId
        await axios.post('/companies/' + id + '/types', {name}).then(function (response) {
          // if (response.status === 200) {
          //   commit('setTypes', response.data)
          // }
          commit('setLoading', false)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // Get list of all Reports
    async getReports({
        commit,
        rootGetters
      }) {
      commit('setLoading', true)
      const id = rootGetters.companyId
      await axios.get('/companies/' + id + '/reports').then(function (response) {
        if(response.status === 200){
          commit('setReports', response.data)
        }
        commit('setLoading', false)
      })
    },
    // Save report
    async saveReport({commit, dispatch, rootGetters},data = null, shared = null) {
      const payload = {
        name: rootGetters.newReport.name,
        view_columns: rootGetters.newReport.view_columns_stringify,
        order_by: rootGetters.newReport.order_by_stringify,
        group_by: rootGetters.newReport.group_by_stringify,
        stack_by: rootGetters.newReport.stack_by_stringify,
        filters: rootGetters.newReport.filters_stringify,
        aggregate: rootGetters.newReport.aggregate_stringify,
        additionalGroupBy: rootGetters.newReport.additionalGroupBy_stringify,
        device_active: rootGetters.newReport.device_active,
        date_from: null,
        date_to: null,
        cover_type: rootGetters.newReport.cover_type,
        type_id: rootGetters.newReport.type_id,
        chart_id: rootGetters.newReport.chart_id,
        id: data === 'new' ? null : rootGetters.newReport.id,
        service_group: rootGetters.newReport.service_group_stringify,
        service: rootGetters.newReport.service_name,
        backward_interval: rootGetters.newReport.backward_interval,
        map: rootGetters.newReport.map ? rootGetters.newReport.map : false,
        shared: shared
      }
      // SQL date format
      let date_from = rootGetters.newReport.date_from
      if (date_from !== null) {
        payload.date_from = typeof date_from === 'object' ? date_from.toISOString().slice(0, 19).replace('T', ' ') : date_from
      }
      let date_to = rootGetters.newReport.date_to
      if (date_to !== null) {
        payload.date_to = typeof date_to === 'object' ? date_to.toISOString().slice(0, 19).replace('T', ' ') : date_to
      }
      commit('setLoading', true)
      const cId = rootGetters.companyId
      const id = payload.id
      if(!id){
        // create new
        return await axios.post('/companies/' + cId + '/reports/', payload).then(function (response) {
          if (response.status === 200) {
            dispatch('getReports').then(function (){
              commit('selectReportType', response.data.type_id)
              commit('selectReport', response.data)
              commit('setLoading', false)
            })
            return response.data
          }
        })
      } else {
        // update report
        return await axios.put('/reports/' + id, payload).then(function (response) {
          if (response.status === 200) {
            dispatch('getReports')
            // commit('setReports', response.data)
            commit('setLoading', false)
            return response.data
          }
        })
      }
    },
    async deleteReport({commit, dispatch}, reportId) {
      commit('setLoading', true)
      if(reportId){
        await axios.delete('/reports/' + reportId).then(function (response) {
          if (response.status === 200) {
            // commit('setLoading', false)
            commit('reset')
            commit('setReportChoosingCollapsed', false)
            dispatch('getReports')
          }
        })
      }
    },
    async getShares({
        commit,
        rootGetters
      }) {
      commit('setLoading', true)
      const id = rootGetters.companyId
      await axios.get('/companies/' + id + '/shares').then(function (response) {
        if(response.status === 200){
          commit('setShares', response.data)
        }
        commit('setLoading', false)
      })
    },
    // Save schedule
    async saveSchedule({commit, dispatch, rootGetters}, data) {
      commit('setLoading', true)
      const cId = rootGetters.companyId
      const id = data.id
      if (!id) {
        // create new
        // data.type_id = rootGetters.userType.id
        await axios.post('/companies/' + cId + '/schedules/', data).then(function (response) {
          if (response.status === 200) {
            dispatch('getReports')
          }
          commit('setLoading', false)
        })
      } else {
        // update schedule
        await axios.put('/schedules/' + id, data).then(function (response) {
          if (response.status === 200) {
            dispatch('getReports')
          }
          commit('setLoading', false)
        })
      }
    },
    async saveShared({commit, dispatch, rootGetters}, data) {
      commit('setLoading', true)
      await axios.post('/companies/' + rootGetters.companyId + '/reports/', data).then(function (response) {
        if (response.status === 200) {
          dispatch('getShares')
        }
        commit('setLoading', false)
      })
    },
    async editShared({commit, dispatch, rootGetters}, data) {
      commit('setLoading', true)
      await axios.put('/shares/' + data.id, data).then(function (response) {
        if (response.status === 200) {
          dispatch('getShares')
        }
        commit('setLoading', false)
      })
    },
    async deleteShared({commit, dispatch}, shareId) {
      commit('setLoading', true)
      if (shareId) {
        await axios.delete('/shares/' + shareId).then(function (response) {
          if (response.status === 200) {
            dispatch('getShares')
          }
        })
        commit('setLoading', false)
      }
    },
    async deleteSchedule({commit, dispatch}, scheduleId) {
      commit('setLoading', true)
      if (scheduleId) {
        await axios.delete('/schedules/' + scheduleId).then(function (response) {
          if (response.status === 200) {
            dispatch('getReports')
          }
        })
        commit('setLoading', false)
      }
    },
    // Get list of all Charts
    async getCharts({
      commit
    }) {
      commit('setLoading', true)
      await axios.get('/charts').then(function (response) {
        if (response.status === 200) {
          commit('setCharts', response.data)
        }
        commit('setLoading', false)
      })
    },
    // Get historical data for report
    async getHistoricalData({
      commit, rootGetters
    }, data) {
      const id = rootGetters.companyId
      const index_id = data.dinamicId
      const service = rootGetters.result.service.name
      let date_from = data.payload.date_from
      if (date_from !== null) {
        date_from = typeof date_from === 'object' ? date_from.toISOString().slice(0, 19).replace('T', ' ') : date_from
      }
      let date_to = data.payload.date_to
      if (date_to !== null) {
         date_to = typeof date_to === 'object' ? date_to.toISOString().slice(0, 19).replace('T', ' ') : date_to
      }
      return await axios.post(`/companies/${id}/history/${index_id}`, {
          backward_interval: data.payload.backward_interval,
          service,
          date_from,
          date_to,
          columns: "{}",
          map: true,
          filters: JSON.stringify(data.payload.activeFilters),
        }).then(function (response) {
        if (response.status === 200) {
          return response
        }
      })
    },
    // Get users for shared report
    async getSharedReportUsers({
      commit, rootGetters
    }, reportId) {
      const id = rootGetters.companyId
      commit('setLoading', true)
      await axios.get('/companies/' + id + '/shares/' + reportId).then(function (response) {
        if (response.status === 200) {
          commit('setSharedUsers', response.data)
        }
        commit('setLoading', false)
      })
    },
    async generateReport({commit, rootGetters}, data) {
      commit('setLoading', true)
      const id = rootGetters.companyId
      return axios.post('/companies/' + id + '/data', data).then(function (response){
        return new Promise((resolve, reject) => {
          if (response.status === 200) {
            let output = response.data
            if (rootGetters.findService(data.service) !== undefined) {
              output.service = rootGetters.findService(data.service)
            }
            commit('setResult', output)
            commit('setLoading', false)
            resolve()
          } else {
            commit('setLoading', false)
            reject()
          }
        })
      })
    },
    async exportToCsv({
      commit, rootGetters
    }, data) {
      const endpoint = data.endpoint
      const id = rootGetters.companyId
      let path
      switch (endpoint) {
        case 'report':
          path = `/companies/${id}/data.csv`
          break
        case 'history':
          path = `/companies/${id}/history/${data.index_id}/data.csv`
          break
      }
      await axios.post(path, data.payload).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'export.csv');
        document.body.appendChild(fileLink);

        fileLink.click();
      })
    },
  },
  modules: {
  },
  strict: false,
  plugins: [logrocketPlugin]
}

const store = new Vuex.Store(reportsStore)
store.registerModule('deviceStore', deviceStore)

export default store